const STABLE_MAP = new Map<any, any>()

/**
 * @param thing Thing of which the first is returned. All others are discarded.
 * @param id Id for the thing you want returned. Make sure it is unique!
 * @returns The very first provided `thing` matching `id` is returned.
 * 
 * Use this when you want to give a React Component a stable prop that is not a [primitive value](https://developer.mozilla.org/en-US/docs/Glossary/Primitive).
 * 
 * This thing exists to make React & JavaScript less annoying, when you just want to return the exact same thing.
 * It can help prevent unnecessary renders by making sure the compared values in React's diffing functions are the same.
 * 
 * Its usage requires the discipline of not using the same id for different things.
 * If you're not sure, do a text search, perhaps we should have the bundler check for these things.
 */
export function stableRefTo<T>(thing: T, id: string): T {
  if (STABLE_MAP.has(id)) return STABLE_MAP.get(id) as T

  STABLE_MAP.set(id, thing)
  return thing
}
